/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import { LayoutGrid, Settings, Pickaxe, TrendingUp } from 'lucide-react';

const stakeholders = [
    {
        id: 1,
        icon: <LayoutGrid className="w-6 h-6 text-[#459ca5]" />,
        title: 'Building Owners & Asset Managers',
        description: 'Portfolio-level visibility and clear data for ESG reporting, cost control, and investment decisions.',
    },
    {
        id: 2,
        icon: <Settings className="w-6 h-6 text-[#459ca5]" />,
        title: 'Facility Managers & Operators',
        description: 'Real-time control and alerts across every site. Act fast, reduce waste, and stay ahead of issues.',
    },
    {
        id: 3,
        icon: <Pickaxe className="w-6 h-6 text-[#459ca5]" />,
        title: 'Contractors & Integrators',
        description: 'Fast installation with pre-configured hardware. Full support before, during and after every deployment.',
    },
    {
        id: 4,
        icon: <TrendingUp className="w-6 h-6 text-[#459ca5]" />,
        title: 'C-Suite & Executive Teams',
        description: 'Clear sustainability metrics, reduced compliance liability, and measurable ROI across the portfolio.',
    },
];

const WhoItsFor = () => {
    return (
        <section className="w-full py-20 lg:py-12 lg:mb-16">
            <div className="containermax-w-[1440px] mx-auto px-6 lg:max-w-screen-xl">

                <div className="mb-16">
                    <span className="text-theme-teal font-bold text-sm tracking-[0.2em] uppercase">
                        WHO IT&apos;S FOR
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight text-black dark:text-white">
                        Built for every stakeholder in the building.
                    </h2>
                    <p className="mt-6 text-gray-500 font-light leading-relaxed text-base lg:text-xl">
                        Nube iO speaks to the engineer installing it, the operator running the building, and the executive reading the report.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {stakeholders.map((person) => (
                        <div
                            key={person.id}
                            className="flex gap-6 p-8 border border-gray-200 rounded-xl hover:shadow-sm transition-shadow duration-300 dark:bg-theme-tarjet/70 dark:border-theme-border"
                        >
                            <div className="w-14 h-14 flex-shrink-0 rounded-lg bg-theme-teal/20 flex items-center justify-center">
                                {person.icon}
                            </div>
                            <div>
                                {(person.title) && (
                                    <h3 className="text-xl font-bold text-gray-900 mb-3 text-black text-base lg:text-lg dark:text-theme-teal">
                                        {person.title}
                                    </h3>
                                )}
                                {(person.description) && (
                                    <p className="text-gray-500  leading-relaxed font-light">
                                        {person.description}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default WhoItsFor;
